// @ts-nocheck
import React, { useCallback } from 'react';
import { compose } from '@/utils';
import { DataTable, TableSkeletonRows } from '@/components';
import { useShipMethodsContext } from './ShipMethodProvider';
import { ActionMenuList, useShipMethodsTableColumns } from './ShipMethodComponent';
import withDialogActions from '@/containers/Dialog/withDialogActions';
import withAlertActions from '@/containers/Alert/withAlertActions';
import { DialogsName } from '@/constants/dialogs';

function ShipMethodsDataTable({ tableProps, openDialog, openAlert }) {
  const { shipMethods = [], isShipMethodsLoading } = useShipMethodsContext();
  const columns = useShipMethodsTableColumns();

  const handleEdit = useCallback(
    (shipMethod) => {
      openDialog(DialogsName.ShipMethodForm, {
        action: 'edit',
        shipMethodId: shipMethod.id,
      });
    },
    [openDialog],
  );

  const handleDelete = (shipMethod) => {
    openAlert('ship-method-delete', { shipMethodId: shipMethod.id });
  };

  return (
    <DataTable
      columns={columns}
      data={shipMethods}
      loading={isShipMethodsLoading}
      headerLoading={isShipMethodsLoading}
      progressBarLoading={isShipMethodsLoading}
      TableLoadingRenderer={TableSkeletonRows}
      ContextMenu={ActionMenuList}
      noInitialFetch={true}
      payload={{
        onEditShipMethod: handleEdit,
        onDeleteShipMethod: handleDelete,
      }}
      rowContextMenu={ActionMenuList}
      {...tableProps}
    />
  );
}

export default compose(withDialogActions, withAlertActions)(ShipMethodsDataTable);
